import { Resource } from '../i18n';

export const it: Resource = {
  form: {
    localeForm: {
      buttons: {
        submit: {
          label: 'Applica',
        },
      },
    },
    newsletterForm: {
      buttons: {
        submit: {
          label: 'Iscriviti',
        },
      },
      outcome: {
        success: {
          body: 'Complimenti da adesso fai parte anche tu del mondo BB Skill!',
          buttons: {
            ok: {
              label: 'Ok',
            },
          },
          title: 'Iscrizione alla newsletter avvenuta con successo',
        },
      },
    },
  },
  misc: {
    addToCart: 'Aggiungi',
    assembledProduct: {
      configure: 'Configura',
      selectAllComponent: 'Seleziona tutti i prodotti',
      selectComponent: 'Seleziona la tua shade',
    },
    outOfStock: 'Attualmente non disponibile',
    storeName: 'BB Skill',
    variant: {
      color: 'Color',
      size: 'Size',
    }
  },
  play: 'Play',
  product: {
    code: 'Cod',
    freeShippingFrom: '<strong>Spedizioni gratuite</strong> a partire da {{freeShippingFromAmount}}',
    promo: 'Promo',
    relatedProduct: {
      title: 'provalo con',
    },
    selectSize: 'Seleziona un colore',
    size: 'Formato',
    size_one: 'Colore',
    size_other: 'Colori',
  },
  productPage: {
    measurement: '<strong>Formato</strong> {{value}} {{measurementUnit}}',
  },
  welcome: 'Benvenuto su store-bbskill!',
};
